export default __webpack_public_path__ + "static/media/makers-collective.5169d0c3.jpg";